import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { AppTextService } from '@fi-shared/app-text';

@Component({
    selector: 'fi-checklist-edit-checkpoint-add-button',
    templateUrl: './checkpoint-add-button.component.html',
    styleUrls: ['./checkpoint-add-button.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-checklist-edit-checkpoint-add-button' },
    standalone: false,
})
export class CheckpointAddButtonComponent {
    @Input() disabled: boolean = false;
    @Input() checklist;

    @Output() addClick = new EventEmitter();

    constructor(private appTextService: AppTextService) {}

    _addClick() {
        this.addClick.emit();
    }

    getAddCheckpointTitle() {
        if (!this.disabled) {
            return '';
        }

        if (this.checklist.IsWithResponses) {
            return this.appTextService.get('checklist.add_checkpoint_delete_responses');
        }
    }
}
